import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["order-id"]
const _hoisted_2 = { class: "col-span-2 flex" }
const _hoisted_3 = { class: "w-20 h-14 mt-2" }
const _hoisted_4 = { class: "flex flex-col justify-start pt-2 text-left" }
const _hoisted_5 = {
  key: 0,
  class: "font-bold text-md"
}
const _hoisted_6 = {
  key: 1,
  class: "font-bold text-md"
}
const _hoisted_7 = { class: "font-normal text-sm" }
const _hoisted_8 = {
  key: 2,
  class: "font-normal text-sm"
}
const _hoisted_9 = { class: "flex flex-col pt-2 text-left break-all" }
const _hoisted_10 = { class: "font-normal text-sm" }
const _hoisted_11 = { class: "font-normal text-sm" }
const _hoisted_12 = {
  key: 0,
  class: "font-normal text-sm"
}
const _hoisted_13 = {
  key: 1,
  class: "font-normal d-flex flex-col text-sm"
}
const _hoisted_14 = { class: "font-normal d-flex gap-1 text-sm" }
const _hoisted_15 = { class: "font-normal d-flex gap-1 text-sm" }
const _hoisted_16 = {
  key: 0,
  class: "col-span-3"
}
const _hoisted_17 = { class: "text-red-600 flex items-center justify-center" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 1,
  class: "col-span-3"
}
const _hoisted_22 = { class: "text-red-600 flex items-center justify-center" }
const _hoisted_23 = {
  key: 2,
  class: "col-span-3"
}
const _hoisted_24 = { class: "text-red-600 flex items-center justify-center" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 1,
  class: "flex justify-between p-2"
}
const _hoisted_29 = { class: "text-slate-600" }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "flex pt-4 pb-2 pl-3" }
const _hoisted_32 = { class: "text-red-500 pr-2" }

import ArrowForward from "../icons/ArrowForward.vue";
import ArrowBackward from "../icons/ArrowBackward.vue";
import MyTravel from "@/components/icons/MyTravel.vue";
import {
  CARRIER_BOOKED_ORDER,
  LOADED_AT_SENDER,
  DIRECTION_DELIVERY,
  DIRECTION_PICKUP,
  ARRIVED_BY_ROAD,
  licensePlateRegex,
  CARRIER_BOOKED_PICKUP,
  COUNTER_CANCELLATION_NEEDED,
} from "@/utils/constants";
import { ref } from "vue";
import DoneDetails from "./DoneDetails.vue";
import { i18n } from "@/i18n/i18n";
import store from "@/store";
import router from "@/router";
import StatusChangeButton from "@/components/StatusChangeButton.vue";
import ElectricLocomotive from "@/components/icons/ElectricLocomotive.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DoneCard',
  props: {
  order: {
    type: Object,
    default: () => ({
      orderId: null,
      orderPosition: null,
      primaryReference: null,
      secondaryReference: null,
      directionType: null,
      transportationState: null,
      loading_unit_formatted: null,
      loadUnit: {
        identifierPrefix: null,
        identifierNumber: null,
        type: null,
        lengthCode: null,
        heightCode: null,
        emptyWeight: null,
        loadWeight: null,
        totalWeight: null,
        loadingStatus: null,
        dangerousGoods: false, // Set default value for boolean properties
        waste: false,
        limitedQuantity: false,
        customsGoods: false,
      },
      train: {
        trainNumber: null,
        operatorId: null,
        operatorName: null,
        shippingDate: null,
        trainClosingTime: null,
        trainArrivalTime: null,
        trainState: null,
      },
      terminal: {
        terminalId: {
          locationCode: null,
          authority: null,
        },
        terminalName: null,
      },
      freightForwarderId: null,
      freightForwarderName: null,
      licensePlate: null,
      driverId: null,
    }),
  },
  index: Number,
  activeOrder: Number || null,
},
  emits: ["activeOrder"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const isEditing = ref(props.activeOrder == -1);
const showCounterCancellationNeeded = ref(false);

const cancelPermission = () => {
  showCounterCancellationNeeded.value = true;

  if (
    props.order.transportationStatus == CARRIER_BOOKED_PICKUP &&
    props.order?.directionType?.toLowerCase() == DIRECTION_PICKUP
  ) {
    showCounterCancellationNeeded.value = true;
  } else {
    cancel();
    toggleOrder();
    router.push("/");
  }
};

const cancel = () => {
  store.dispatch("OrderStore/removeTour", {
    order: props.order,
    index: props.index,
  });
};

const cancelPickUpOrderCamcellationNeeded = () => {
  let newTransportationStatus = "";
  switch (props.order.transportationStatus) {
    case CARRIER_BOOKED_PICKUP:
      newTransportationStatus = COUNTER_CANCELLATION_NEEDED;
      break;
    default:
      break;
  }

  if (newTransportationStatus) {
    store.dispatch("OrderStore/updateTourOrder", {
      order: props.order,
      index: props.index,
      params: {
        transportationStatus: newTransportationStatus,
      },
    });
  } else {
    console.error(
      "We don't know how to handle this transportationStatus yet. Please update code."
    );
  }

  showCounterCancellationNeeded.value = false;
  toggleOrder();
};

const toggleOrder = () => {
  if (props.activeOrder == null) {
    router.push(
      `/done/${props.order.orderId}/${props.order.orderPosition}/${props.order.directionType}`
    );
  } else {
    router.push("/done");
  }
};

const isNotProduction = () => {
  return process.env.NODE_ENV !== "production";
};

const formatKg = (value: string | number) => {
  if (!value) return;
  value = parseFloat(value as string);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " kg";
};

const licensePlateInvalid = () => {
  if (!props.order.licensePlate) return true;
  return !licensePlateRegex.test(props.order.licensePlate);
};

const setButtonString = () => {
  if (props.order.transportationStatus === CARRIER_BOOKED_ORDER) {
    return i18n.global.t("tour.taken_over_at_sender");
  } else if (props.order.transportationStatus === LOADED_AT_SENDER) {
    return i18n.global.t("tour.arrival_terminal");
  } else if (props.order.transportationStatus === ARRIVED_BY_ROAD) {
    return i18n.global.t("tour.delivered_to_terminal");
  } else {
    return i18n.global.t("tour.delivered_to_terminal"); // TODO placeholder
  }
};

return (_ctx: any,_cache: any) => {
  const _component_db_icon = _resolveComponent("db-icon")!

  return (__props.activeOrder == null || __props.activeOrder == __props.index)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "bg-white w-full rounded-lg shadow-xl",
        "order-id": __props.order.orderId
      }, [
        _createElementVNode("div", {
          onClick: toggleOrder,
          class: "grid grid-cols-3 mx-2 border-b pt-2 opacity-50"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (__props.order?.directionType?.toLowerCase() == _unref(DIRECTION_DELIVERY))
                ? (_openBlock(), _createBlock(ArrowForward, { key: 0 }))
                : (_openBlock(), _createBlock(ArrowBackward, { key: 1 }))
            ]),
            _createElementVNode("div", _hoisted_4, [
              (__props.order?.directionType?.toLowerCase() == _unref(DIRECTION_DELIVERY))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("order.delivery")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("order.pick_up")), 1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(__props.order.terminal.terminalName), 1),
              (isNotProduction())
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Status: " + _toDisplayString(__props.order.transportationStatus), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("order.ref")) + ": " + _toDisplayString(__props.order.primaryReference), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("order.origRef")) + ": " + _toDisplayString(__props.order.secondaryReference), 1),
            (__props.activeOrder == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(__props.order?.loadUnit?.identifierPrefix) + _toDisplayString(__props.order?.loadUnit?.identifierNumber), 1))
              : _createCommentVNode("", true),
            (__props.activeOrder == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("order.loadWeightShort")) + ": " + _toDisplayString(formatKg(__props.order?.loadUnit?.loadWeight)), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("order.emptyWeightShort")) + ": " + _toDisplayString(formatKg(__props.order?.loadUnit?.emptyWeight)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (
          __props.order.loadUnit.customsGoods &&
          (__props.order.loadUnit.dangerousGoods ||
            __props.order.loadUnit.waste ||
            __props.order.loadUnit.limitedQuantity)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_db_icon, {
                    icon: "info",
                    variant: "24-outline"
                  }),
                  (__props.order.loadUnit.dangerousGoods)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("order.error_customs_with_dangerous", {
              type: _ctx.$t("order.dangerous_goods"),
            })), 1))
                    : _createCommentVNode("", true),
                  (__props.order.loadUnit.waste)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("order.error_customs_with_dangerous", {
              type: _ctx.$t("order.waste"),
            })), 1))
                    : _createCommentVNode("", true),
                  (__props.order.loadUnit.limitedQuantity)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("order.error_customs_with_dangerous", {
              type: _ctx.$t("order.limitedQuantity"),
            })), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (__props.order.loadUnit.customsGoods)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_db_icon, {
                      icon: "info",
                      variant: "24-outline"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.error_customs")), 1)
                  ])
                ]))
              : (
          __props.order.loadUnit.dangerousGoods ||
          __props.order.loadUnit.waste ||
          __props.order.loadUnit.limitedQuantity
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_db_icon, {
                        icon: "info",
                        variant: "24-outline"
                      }),
                      (__props.order.loadUnit.dangerousGoods)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("order.error_goods", { type: _ctx.$t("order.dangerous_goods") })), 1))
                        : _createCommentVNode("", true),
                      (__props.order.loadUnit.waste)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("order.error_goods", { type: _ctx.$t("order.waste") })), 1))
                        : _createCommentVNode("", true),
                      (__props.order.loadUnit.limitedQuantity)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("order.error_goods", { type: _ctx.$t("order.limitedQuantity") })), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]),
        (__props.activeOrder != null)
          ? (_openBlock(), _createBlock(DoneDetails, {
              key: 0,
              readonly: true,
              order: __props.order
            }, null, 8, ["order"]))
          : (
        __props.activeOrder == null &&
        __props.order.transportationStatus !== _unref(COUNTER_CANCELLATION_NEEDED)
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(ElectricLocomotive, { disabled: "true" }),
                  _createTextVNode(_toDisplayString(__props.order.train.trainNumber), 1)
                ]),
                _createVNode(StatusChangeButton, {
                  order: __props.order,
                  index: __props.index,
                  classList: "hydrated mt-2 px-2",
                  variant: "primary",
                  disabled: true
                }, null, 8, ["order", "index"])
              ]))
            : _createCommentVNode("", true),
        (__props.order.transportationStatus === _unref(COUNTER_CANCELLATION_NEEDED))
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(MyTravel, { color: "red" }),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("tour.counter_cancellation_needed")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})